export interface RankingData {
  topBookers: RankData;
  topCallers: RankData;
  highestBookingRate: RankData;
}

export interface RankData {
  currentAgent: CurrentUserRankData;
  agents: AgentsRankData[];
}

export interface CurrentUserRankData {
  position: number;
  count: number;
}
export interface AgentsRankData {
  name: string;
  count: number;
}

export interface AgentHistoryData {
  hour: Date;
  callCount: number;
  bookCount: number;
}

export interface LeaderboardDto {
  currentUser: UserDataDto;
  topBookers: RatingDto;
  topCallers: RatingDto;
  highestBookingRate: RatingDto;
  topShowRate: RatingDto;
}

export interface RatingDto {
  currentUserPosition: number;
  currentUserCriteriaCount: number;
  leaderboard: TopBooker[];
}

export interface TopBooker {
  azureId: string;
  fullName: string;
  count: number;
}

export interface UserDataDto {
  fullName: string;
  azureId: string;
  email: string;
  levelName: string;
  currentXp: number;
  nextLevelXp: number;
  currentLevel: number;
  userActions: UserAction[];
  slotsForToday: SlotInfoDto[];
  achievements: AchievementProgressDto[];
  selectedBookingButton: string | undefined;
}

export interface AchievementProgressDto {
  id: number;
  name: string;
  description: string;
  progress: number;
  points: number;
  isCompleted: boolean;
  receivedAt: string | undefined;
}

export interface Achievement {
  id: number;
  name: string;
  description: string;
  points: number;
  target: number;
  actions: string[] | undefined;
  days: string[] | undefined;
  fromHour: string | undefined;
  toHour: string | undefined;
  icon: string | undefined;
  dueDate: string | undefined;
  isAccumulative: boolean | undefined;
}

export interface UserAction {
  when: string;
  actionType: string;
  points: number;
}

export interface SlotInfoDto {
  externalAppointmentId: string | null | undefined;
  startTime: string | null | undefined;
  whenBooked: string | null | undefined;
  endTime: string;
  status: string;
}

export interface ActionDto {
  actionId: number;
  actionType: string;
  points: number;
}

export interface TeamModel {
  id: number;
  name: string;
  leadId: string;
  observers: string[];
  icon?: string | null | undefined; // URL to the team icon
}

export interface TeamMemberModel {
  id: string;
  fullName: string;
}

export interface HourlyData {
  todayHourlyData: HourData[];
  pastHourlyData: HourData[];
}

export interface HourData {
  hour: string;
  amount: number;
  pastAmount: number;
}

export interface MetricsData {
  todayMetrics: Metric[];
  pastMetrics: Metric[];
}

export interface Metric {
  type: string;
  value: string;
}

export interface Metrics {
  hourlyData: HourData[];
  metricData: MetricsData;
}

export interface RatingsResponse {
  topBookers: RatingDto;
  topShowRate: RatingDto;
  mostBookingsPerAssignment: RatingDto;
  assignments: RatingDto;
  assignmentsPerHour: RatingDto;
  bookingsPerHour: RatingDto;
  nearestAppointmentsPerToday: RatingDto;
}

export interface UserModel {
  id: string;
  fullName: string;
  teamId: number;
}

export interface PowerHourConfig {
  id: number;
  feId: string;
  fromDayOfWeek: DayOfWeek;
  untilDayOfWeek: DayOfWeek;
  startTimeUtc: string; // Representing TimeOnly as a string in "HH:mm:ss" format
  endTimeUtc: string; // Representing TimeOnly as a string in "HH:mm:ss" format
  isDeleted: boolean;
}

export interface PowerHourData {
  id: number;
  createdAt: Date;
  endTimeUtc: Date;
  teamId: number;
  teamName: string;
  totalExperience: number;
  contributors: string;
  experiencePerContributor: number;
}

export enum DayOfWeek {
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}
